import "./_style.css"
import BreadCrumbs from "../../components/BreadCrumbs";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import {ThemeProvider, createTheme} from '@mui/material/styles';
// import Button from "../../components/Button";
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';


const icecatPalette: any = {
    primary: {
        main: "#21409b",
        // light: '#284dbd',
        // dark: '#284dbd',
    },
    secondary: {
        main: "#a8b3bd"
    },
}

const themeMultiSelect = createTheme({
    palette: icecatPalette,

    components: {

        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: "0 0 0 8px !important",
                },
            },
        },

        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: "#21409b",
                    fontSize: "1.15rem"
                }

            }
        },


        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: "0.8rem"
                }
            }
        },

        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "0.95rem",
                    padding: "0 !important"
                    // paddingBottom: "10px"
                },
            }
        },
    }
})


const theme = createTheme({
    palette: icecatPalette,

    components: {

        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    padding: "3px 5px !important",
                    fontSize: "0.9rem !important",
                },
            },
        },

        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "0.95rem",
                    // paddingBottom: "10px"
                },
            }
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    fontSize: "0.9rem",
                    textTransform: "none",
                    backgroundColor: "#21409b",
                    ":hover": {backgroundColor: "#284dbd"}
                },
            }
        },

    },
});


export default function DownloadsHome() {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Download reports', 'link': ''}
    ]

    const reports = [
        {value: '', label: ''},
        {value: 'full_taxonomy', label: 'Full taxonomy report'},
        {value: 'brands', label: 'Brands report'},
        {value: 'families', label: 'Families report'},
        {value: 'categories', label: 'Categories report'},
        {value: 'features', label: 'Features report'},
        {value: 'groups', label: 'Groups report'},
        {value: 'locales', label: 'Locales report'},
        {value: 'countries', label: 'Countries report'},
        {value: 'cats_tree', label: 'Categories Tree report'},
        {value: 'leaf_paths', label: 'Leaf categories paths'},
        {value: 'intloc_values', label: 'INT-Local values (vocabulary)'},
        {value: 'feat_logos', label: 'Feature Logos rules'},
    ];

    const initialReportData: any = {
        reportType: '',
        reportLang: 'english',
        email: '',
        fulltaxFeatStatus: [],
        fulltaxValuesView: ''
    }

    const [reportData, setReportData] = useState<any>(initialReportData)

    function handleInputChange(event: any) {
        let name = event.target.name
        let value = event.target.value

        if (name === 'fulltaxFeatStatus') {
            setReportData((prev: any) => {
                return {...prev, [name]: (typeof value === 'string' ? value.split(',') : value)}
            })
        }

        setReportData((prev: any) => {
            return {...prev, [name]: value}
        })

    }

    function handleSendReport() {
        // console.log('send report clicked')

        fetch(`http://${serverIP}/getreport/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({user: user.username}),
        }).then(res => res.json())
            .then((data) => {
                console.log(data)
                // if (data.status === 200) {
                //     setIsSaved(prev => !prev)
                //     setMapInfo((prev: any) => {
                //         return {...prev, map_status: 'mapped'}
                //     })
                //     // console.log('Success')
                // }
                // // console.log(data)
            })




        // setReportData(initialReportData)

    }

    const featStatuses = ['searchable', 'mandatory', 'ordinary', 'optional (grey)']


    return (
        <>

            {/*<div className="outer-container">*/}
            {/*    <div className="inner-container">*/}
            {/*    </div>*/}
            {/*</div>*/}

            <ThemeProvider theme={theme}>

                <BreadCrumbs user={user} itemsLinks={crumbItems}/>

                <div className="downloads-container">

                    <div className="report-settings">

                        <div className="report-label">Select report type:</div>
                        <TextField
                            select
                            id="report-type"
                            size="small"
                            variant="outlined"    // standard
                            name="reportType"
                            value={reportData.reportType}
                            onChange={handleInputChange}
                            // label="Select"
                            // defaultValue="EUR"
                            // helperText="Please select your currency"
                        >
                            {reports.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>


                        <div className="report-label">Report parameters:</div>

                        <div className="report-parameters">

                            <div style={{fontSize: "0.75rem", paddingTop: "4px"}}>Language:</div>
                            <select
                                id="report-lang"
                                name="reportLang"
                                value={reportData.reportLang}
                                disabled
                                // onChange={handleInputChange}
                            >
                                <option value=""></option>
                                <option value="english">English</option>
                            </select>


                            {reportData.reportType === 'full_taxonomy' && <>
                                {/* select multiple Feature Statuses for Full Taxonomy report */}
                                <div style={{fontSize: "0.75rem", paddingTop: "4px"}}>Features status:</div>
                                <ThemeProvider theme={themeMultiSelect}>
                                    <Select
                                        id="fulltax-feature-status"
                                        name="fulltaxFeatStatus"
                                        size="small"
                                        multiple
                                        value={reportData.fulltaxFeatStatus}
                                        onChange={handleInputChange}
                                        // input={<OutlinedInput label="Tag"/>}
                                        renderValue={(selected) => selected.join(', ')}
                                        sx={{backgroundColor: "white", padding: "0 !important", margin: "0 !important"}}
                                    >
                                        {featStatuses.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                <Checkbox checked={reportData.fulltaxFeatStatus.indexOf(item) > -1}/>
                                                <ListItemText primary={item}/>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </ThemeProvider>

                                {/* values Collapsed (one cell delimited \n) or Expanded (one line = feature-value) */}
                                <div style={{fontSize: "0.75rem", paddingTop: "4px"}}>Values view:</div>
                                <select
                                    id="fulltax-values-view"
                                    name="fulltaxValuesView"
                                    value={reportData.fulltaxValuesView}
                                    onChange={handleInputChange}
                                >
                                    <option value=""></option>
                                    <option value="expand">epxpanded</option>
                                    <option value="collapse">collapsed</option>
                                </select>
                            </>}


                        </div>

                        {/* Email to which a report is sent */}
                        <div className="report-label">Your email:</div>
                        <TextField
                            id="email"
                            name="email"
                            size="small"
                            variant="outlined"    // standard
                            value={reportData.email}
                            onChange={handleInputChange}
                        />

                    </div>

                    {/* Button send the report */}
                    <div className="send-report-button">
                        <Button
                            size="small"
                            variant="contained"
                            onClick={handleSendReport}
                            disabled={!(reportData.reportType && reportData.email)}
                        >Send report</Button>
                    </div>


                </div>
            </ThemeProvider>
        </>

    )
}
